async function getProductSubscriptions(platformId) {
  try {
    const productId = platformId.replace("gid://shopify/Product/", "");
    const response = await fetch(`/apps/proxy/app/getSkioSubscriptionPlans/${productId}`);
    const data = await response.json();
    const filteredSellingPlans = data[0].SellingPlanGroupResources
      .flatMap(planGroup =>
        planGroup.SellingPlanGroup.SellingPlans.map(plan => ({
          name: plan.name,
          value: plan.platformId.replace("gid://shopify/SellingPlan/", "")
        }))
      );

    const groupedPlans = filteredSellingPlans.reduce((acc, plan) => {
      if (!plan.name.includes("for 6 months")) {
        acc["cancelAnyTime"] = acc["cancelAnyTime"] || [];
        acc["cancelAnyTime"].push({
          name: plan.name,
          value: plan.value
        });
      }
      return acc;
    }, {});

    return groupedPlans
  } catch (error) {
    throw error;
  }
}

async function fetchAvailablePlans(productGid) {
  const plans = await getProductSubscriptions(productGid);
  return plans;
}

function renderPlanSelects(availablePlans) {
  const cancelAnyTimeSelect = document.getElementById('cancelAnyTimePlanList');
  availablePlans.cancelAnyTime.sort((a, b) =>
    a.name.localeCompare(b.name)
  )
  const cancelAnyTimeChoices = availablePlans.cancelAnyTime
    .map(plan => `<option ${plan.value === "2205581569" && 'selected'} value='${plan.value}' ${plan.name.includes('15') && 'selected'}>${plan.name}</option>`)
    .join("");
  cancelAnyTimeSelect.innerHTML = cancelAnyTimeChoices;
}

function addToSubscription(isSubscription) {
  const selectedPlan = document.querySelectorAll('.selling-plan-select')
  const sellingPlanId = isSubscription ? (document.getElementById('cancelAnyTimePlanList').value || "2205581569") : "";

  selectedPlan.forEach((input) => {
    input.value = sellingPlanId
  })
}